module.exports = __webpack_public_path__ + "img/data3.14e33bee.png";